import { render, staticRenderFns } from "./AttributionPage.vue?vue&type=template&id=7d4fcdd7"
import script from "./AttributionPage.vue?vue&type=script&lang=js"
export * from "./AttributionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports